


























































































































import Vue from "vue"
import {Route} from "vue-router"
import {Locale} from "vue-i18n"
import {routes} from "@/router/router"
import {officeService} from "@/model/service/office/office-service"

export default Vue.extend({
  data() {
    return {
      activeIndex: "0",
      routes: routes,
      officeService: officeService,
      images: [
        {url: require("@/assets/image/united-kingdom.png")},
        {url: require("@/assets/image/croatia.png")},
        {url: require("@/assets/image/slovenia.png")}
      ]
    }
  },
  methods: {
    getDisplayableRoutes(routes: Route[]) {
      return routes.filter(
        route =>
          !route.meta.excludeFromNavbar &&
          (!route.meta.allowedRoles ||
              (!!route.meta.allowedRoles && this.$store.getters.employeeHasRequiredRole(route.meta.allowedRoles))) &&
          (this.$store.getters.menuEnabledForCompany(route.meta.key))
      )
    },
    getTitle() {
      if (this.$t(`header.routes.${this.$router.currentRoute.meta.key}.title`)) {
        return this.$t(`header.routes.${this.$router.currentRoute.meta.key}.title`)
      }
      return this.$t(`header.routes.${this.$router.currentRoute.meta.key}.name`)
    },
    getMenuItemClass(route: Route, index: number) {
      let cssClass = "fas " + route.meta.icon
      cssClass += this.activeIndex.startsWith(index.toString()) ? " primary" : ""
      return cssClass
    },
    changeLocale(locale: Locale) {
      if (locale !== this.$i18n.locale) {
        this.$i18n.locale = locale
      }
      const office = this.$store.getters.loggedUser.office
      office.lang = this.$i18n.locale.toString().toUpperCase()
      this.officeService.modify(office)
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push({path: "/login"})
      })
    }
  },
  watch: {
    $route() {
      const vm = this
      let index = ""
      vm.routes.forEach((route: any, routeIndex) => {
        if (!!route.children) {
          route.children.forEach((child: any, childIndex: number) => {
            if (child.path === vm.$router.currentRoute.path) {
              index = routeIndex + "-" + childIndex
            }
          })
        } else if (route.path === vm.$router.currentRoute.path) {
          index += routeIndex
        }
      })
      vm.activeIndex = index
      const navMenu = this.$refs.navMenu as any
      navMenu.activeIndex = index
      this.$forceUpdate()
    }
  },
  computed: {
    loggedUser(): any {
      return this.$store.getters.loggedUser
    }
  }
})
